import { Component, OnInit } from '@angular/core';
import { DataSharingService } from '@EfsServices/data-sharing.service';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.css'],
  standalone: false
})
export class HelpPageComponent implements OnInit {

  showSetupHelp = false;
  showSI = false;
  showPH = false;
  showPS = false;
  showPT = false;
  showPM = false;
  showCS = false;
  showRS = false;
  showRA = false;
  showNS = false;
  showPK = false;
  showNCS = false;
  showNDT = false;
  showCLS = false;
  showSUSICC = false;
  showAR = false;
  showBOM = false;

  constructor(
    private dataSharingService: DataSharingService,
  ) { }

  ngOnInit() {
    this.displayPdf();
  }

  // services
  // end of services

  displayPdf() {
    if (sessionStorage.getItem('helpPage') === 'Special Instructions') {
      this.showSI = true;
    } else if (sessionStorage.getItem('helpPage') === 'Setup') {
      this.showSetupHelp = true;
    } else if (sessionStorage.getItem('helpPage') === 'Prehold') {
      this.showPH = true;
    } else if (sessionStorage.getItem('helpPage') === 'Production Method Group') {
      this.showPM = true;
    } else if (sessionStorage.getItem('helpPage') === 'Plan Template') {
      this.showPT = true;
    } else if (sessionStorage.getItem('helpPage') === 'Production Setup') {
      this.showPS = true;
    } else if (sessionStorage.getItem('helpPage') === 'Corp Setup') {
      this.showCS = true;
    } else if (sessionStorage.getItem('helpPage') === 'Role Administration') {
      this.showRA = true;
    } else if (sessionStorage.getItem('helpPage') === 'Package Template') {
      this.showPK = true;
    } else if (sessionStorage.getItem('helpPage') === 'National Setup') {
      this.showNS = true;
    } else if (sessionStorage.getItem('helpPage') === 'Rule Setup') {
      this.showRS = true;
    } else if (sessionStorage.getItem('helpPage') === 'National Corp Setup') {
      this.showNCS = true;
    } else if (sessionStorage.getItem('helpPage') === 'National Dispatch Template') {
      this.showNDT = true;
    } else if (sessionStorage.getItem('helpPage') === 'Client Summary') {
      this.showCLS = true;
    } else if (sessionStorage.getItem('helpPage') === 'Single User Setup ICC') {
      this.showSUSICC = true;
    } else if (sessionStorage.getItem('helpPage') === 'Archival and Retrieval') {
      this.showAR = true;
    } else if (sessionStorage.getItem('helpPage') === 'MK Bill of Material') {
      this.showBOM = true;

    } else {
      this.showSetupHelp = true;
    }
  }

}
